import { RdPathLoader, RdProjectsLoader } from '@neo.tax/rd/organisms';
import { Path } from '@neo.tax/shared';

import { useRdProjectsRedirect } from './hooks';

export const RdProjects = (): React.ReactElement => (
  <RdPathLoader path={Path.RD_PROJECTS} useRedirect={useRdProjectsRedirect}>
    <RdProjectsLoader />
  </RdPathLoader>
);
